import React from 'react';
import './Footer.css';

const Footer = () => {

   const year = new Date().getFullYear();

   return (
      
      <div className='footer'>
      <div>
      <a href='https://www.linkedin.com/in/prosourav/'>
      <img src="https://img.icons8.com/fluent/30/ffffff/linkedin.png" alt='' className='logo-footer'/>
      </a>
      <a href="https://github.com/prosourav">
      <img src="https://img.icons8.com/fluent/30/ffffff/github.png" alt='' className='logo-footer'/>
      </a>
      <a href="https://www.facebook.com/prosouravhere">
      <img src="https://img.icons8.com/android/22/4a90e2/facebook-new.png"  alt='' className='logo-footer'/>
      </a>
      </div>
      <h6>Designed and Developed by Sourav Saha</h6>
      <p>Copyright © {year}, All Rights Reserved</p>
      </div>
   );
};

export default Footer;